import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=5189afda&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=5189afda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189afda",
  null
  
)

export default component.exports